module.exports = __webpack_public_path__ + "static/img/guide-purchase-gmoney.df1df94.png";